export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-Direct-Message-Box-182f7d52ef5c69d0f8663c9cf54161da.png";